/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { preRegistrationControllerCreateV1 } from '../fn/pre-registration/pre-registration-controller-create-v-1';
import { PreRegistrationControllerCreateV1$Params } from '../fn/pre-registration/pre-registration-controller-create-v-1';
import { preRegistrationControllerDeleteV1 } from '../fn/pre-registration/pre-registration-controller-delete-v-1';
import { PreRegistrationControllerDeleteV1$Params } from '../fn/pre-registration/pre-registration-controller-delete-v-1';
import { preRegistrationControllerFindAllV1 } from '../fn/pre-registration/pre-registration-controller-find-all-v-1';
import { PreRegistrationControllerFindAllV1$Params } from '../fn/pre-registration/pre-registration-controller-find-all-v-1';
import { preRegistrationControllerFindByIdV1 } from '../fn/pre-registration/pre-registration-controller-find-by-id-v-1';
import { PreRegistrationControllerFindByIdV1$Params } from '../fn/pre-registration/pre-registration-controller-find-by-id-v-1';
import { preRegistrationControllerSearchCursorV1 } from '../fn/pre-registration/pre-registration-controller-search-cursor-v-1';
import { PreRegistrationControllerSearchCursorV1$Params } from '../fn/pre-registration/pre-registration-controller-search-cursor-v-1';
import { preRegistrationControllerSearchV1 } from '../fn/pre-registration/pre-registration-controller-search-v-1';
import { PreRegistrationControllerSearchV1$Params } from '../fn/pre-registration/pre-registration-controller-search-v-1';
import { preRegistrationControllerUpdateV1 } from '../fn/pre-registration/pre-registration-controller-update-v-1';
import { PreRegistrationControllerUpdateV1$Params } from '../fn/pre-registration/pre-registration-controller-update-v-1';
import { PreRegistrationDto } from '../models/pre-registration-dto';

@Injectable({ providedIn: 'root' })
export class PreRegistrationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `preRegistrationControllerSearchV1()` */
  static readonly PreRegistrationControllerSearchV1Path = '/api/v1/pre-registration/search';

  /**
   * 사전 관람 신청 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preRegistrationControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerSearchV1$Response(params?: PreRegistrationControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<PreRegistrationDto>;
}>> {
    return preRegistrationControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 사전 관람 신청 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preRegistrationControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerSearchV1(params?: PreRegistrationControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<PreRegistrationDto>;
}> {
    return this.preRegistrationControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<PreRegistrationDto>;
}>): OffsetPaginationDto & {
'items'?: Array<PreRegistrationDto>;
} => r.body)
    );
  }

  /** Path part for operation `preRegistrationControllerSearchCursorV1()` */
  static readonly PreRegistrationControllerSearchCursorV1Path = '/api/v1/pre-registration/search/cursor';

  /**
   * 사전 관람 신청 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preRegistrationControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerSearchCursorV1$Response(params?: PreRegistrationControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<PreRegistrationDto>;
}>> {
    return preRegistrationControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 사전 관람 신청 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preRegistrationControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerSearchCursorV1(params?: PreRegistrationControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<PreRegistrationDto>;
}> {
    return this.preRegistrationControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<PreRegistrationDto>;
}>): CursorPaginationDto & {
'items'?: Array<PreRegistrationDto>;
} => r.body)
    );
  }

  /** Path part for operation `preRegistrationControllerFindAllV1()` */
  static readonly PreRegistrationControllerFindAllV1Path = '/api/v1/pre-registration';

  /**
   * 모든 사전 관람 신청 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preRegistrationControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerFindAllV1$Response(params?: PreRegistrationControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PreRegistrationDto>>> {
    return preRegistrationControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 사전 관람 신청 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preRegistrationControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerFindAllV1(params?: PreRegistrationControllerFindAllV1$Params, context?: HttpContext): Observable<Array<PreRegistrationDto>> {
    return this.preRegistrationControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PreRegistrationDto>>): Array<PreRegistrationDto> => r.body)
    );
  }

  /** Path part for operation `preRegistrationControllerCreateV1()` */
  static readonly PreRegistrationControllerCreateV1Path = '/api/v1/pre-registration';

  /**
   * 사전 관람 신청 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preRegistrationControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  preRegistrationControllerCreateV1$Response(params: PreRegistrationControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PreRegistrationDto>> {
    return preRegistrationControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 사전 관람 신청 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preRegistrationControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  preRegistrationControllerCreateV1(params: PreRegistrationControllerCreateV1$Params, context?: HttpContext): Observable<PreRegistrationDto> {
    return this.preRegistrationControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PreRegistrationDto>): PreRegistrationDto => r.body)
    );
  }

  /** Path part for operation `preRegistrationControllerFindByIdV1()` */
  static readonly PreRegistrationControllerFindByIdV1Path = '/api/v1/pre-registration/{id}';

  /**
   * 사전 관람 신청 id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preRegistrationControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerFindByIdV1$Response(params: PreRegistrationControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PreRegistrationDto>> {
    return preRegistrationControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 사전 관람 신청 id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preRegistrationControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerFindByIdV1(params: PreRegistrationControllerFindByIdV1$Params, context?: HttpContext): Observable<PreRegistrationDto> {
    return this.preRegistrationControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PreRegistrationDto>): PreRegistrationDto => r.body)
    );
  }

  /** Path part for operation `preRegistrationControllerDeleteV1()` */
  static readonly PreRegistrationControllerDeleteV1Path = '/api/v1/pre-registration/{id}';

  /**
   * 사전 관람 신청 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preRegistrationControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerDeleteV1$Response(params: PreRegistrationControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return preRegistrationControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 사전 관람 신청 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preRegistrationControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  preRegistrationControllerDeleteV1(params: PreRegistrationControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.preRegistrationControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `preRegistrationControllerUpdateV1()` */
  static readonly PreRegistrationControllerUpdateV1Path = '/api/v1/pre-registration/{id}';

  /**
   * 사전 관람 신청 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preRegistrationControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  preRegistrationControllerUpdateV1$Response(params: PreRegistrationControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PreRegistrationDto>> {
    return preRegistrationControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 사전 관람 신청 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preRegistrationControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  preRegistrationControllerUpdateV1(params: PreRegistrationControllerUpdateV1$Params, context?: HttpContext): Observable<PreRegistrationDto> {
    return this.preRegistrationControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PreRegistrationDto>): PreRegistrationDto => r.body)
    );
  }

}
